// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3omrh","col":"styles_col__23RFa","fulfillmentStatus":"styles_fulfillmentStatus__1atDQ","emailCol":"styles_emailCol__2ckSv"};